var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) if (e.indexOf(p[i]) < 0)
            t[p[i]] = s[p[i]];
    return t;
};
import * as React from 'react';
import * as PropTypes from 'prop-types';
import * as _ from 'lodash';
import { UIComponent, createShorthandFactory, commonPropTypes } from '../../lib';
import Input from '../Input/Input';
import Ref from '../Ref/Ref';
/**
 * A DropdownSearchInput is a sub-component of a Dropdown that also has a search function, used to display the search input field.
 */
var DropdownSearchInput = /** @class */ (function (_super) {
    __extends(DropdownSearchInput, _super);
    function DropdownSearchInput() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.handleInputRef = function (inputNode) {
            _.invoke(_this.props, 'inputRef', inputNode);
        };
        _this.handleFocus = function (e) {
            _.invoke(_this.props, 'onFocus', e, _this.props);
        };
        _this.handleInputKeyDown = function (e) {
            _.invoke(_this.props, 'onInputKeyDown', e, _this.props);
        };
        _this.handleInputBlur = function (e) {
            _.invoke(_this.props, 'onInputBlur', e, _this.props);
        };
        _this.handleKeyUp = function (e) {
            _.invoke(_this.props, 'onKeyUp', e, _this.props);
        };
        return _this;
    }
    DropdownSearchInput.prototype.renderComponent = function (_a) {
        var rest = _a.rest, styles = _a.styles;
        var _b = this.props, accessibilityWrapperProps = _b.accessibilityWrapperProps, accessibilityInputProps = _b.accessibilityInputProps, placeholder = _b.placeholder;
        var innerRef = accessibilityWrapperProps.innerRef, accessibilityWrapperPropsRest = __rest(accessibilityWrapperProps, ["innerRef"]);
        return (React.createElement(Ref, { innerRef: innerRef },
            React.createElement(Input, __assign({ inputRef: this.handleInputRef, onFocus: this.handleFocus, onKeyUp: this.handleKeyUp, wrapper: __assign({ styles: styles.wrapper }, accessibilityWrapperPropsRest), input: __assign({ type: 'text', styles: styles.input, placeholder: placeholder, onBlur: this.handleInputBlur, onKeyDown: this.handleInputKeyDown }, accessibilityInputProps) }, rest))));
    };
    DropdownSearchInput.displayName = 'DropdownSearchInput';
    DropdownSearchInput.className = 'ui-dropdown__searchinput';
    DropdownSearchInput.propTypes = __assign({}, commonPropTypes.createCommon({
        children: false,
        content: false,
    }), { accessibilityInputProps: PropTypes.object, accessibilityWrapperProps: PropTypes.object, inputRef: PropTypes.func, onFocus: PropTypes.func, onInputBlur: PropTypes.func, onInputKeyDown: PropTypes.func, onKeyUp: PropTypes.func, placeholder: PropTypes.string });
    return DropdownSearchInput;
}(UIComponent));
DropdownSearchInput.create = createShorthandFactory(DropdownSearchInput);
export default DropdownSearchInput;
